// src/cleanupCookies.js
const COG_PREFIX = 'CognitoIdentityServiceProvider.';

function deleteCookieEverywhere(name) {
  // broad path
  document.cookie = `${name}=; Path=/; Max-Age=0; Secure; SameSite=Lax`;
  // try parent domain (e.g., .example.com)
  try {
    const parts = window.location.hostname.split('.');
    if (parts.length >= 2) {
      const parent = `.${parts.slice(-2).join('.')}`;
      document.cookie = `${name}=; Domain=${parent}; Path=/; Max-Age=0; Secure; SameSite=Lax`;
    }
  } catch { /* no-op */ }
}

/**
 * Legacy nuke: remove all Cognito cookies (you already had something like this)
 */
export function cleanupLegacyCognitoCookies() {
  if (typeof document === 'undefined') return;
  const cookieNames = document.cookie.split(';').map(c => c.split('=')[0].trim());
  cookieNames.forEach((name) => {
    if (!name.startsWith(COG_PREFIX)) return;
    deleteCookieEverywhere(name);
  });
}

/**
 * Remove Cognito cookies that belong to the WRONG clientId / userPool.
 * Call this BEFORE Amplify.configure(...)
 */
export function cleanupWrongCognitoCookies(expectedClientId, expectedUserPoolId) {
  if (typeof document === 'undefined') return;

  const cookies = document.cookie.split(';').map(s => s.trim());
  const names = cookies.map(c => c.split('=')[0]);
  const expectedPrefix = `${COG_PREFIX}${expectedClientId}.`;

  // 1) Delete any Cognito cookie whose prefix clientId != expected
  names.forEach((name) => {
    if (!name.startsWith(COG_PREFIX)) return;
    if (!name.startsWith(expectedPrefix)) {
      deleteCookieEverywhere(name);
    }
  });

  // 2) (Optional) Double-check the idToken issuer matches the expected userPoolId.
  //    If it doesn't, wipe that whole clientId namespace too.
  const idTokenName = names.find(n =>
    n.startsWith(expectedPrefix) && n.endsWith('.idToken')
  );
  if (idTokenName && expectedUserPoolId) {
    try {
      const value = cookies.find(c => c.startsWith(`${idTokenName}=`))?.split('=')[1] || '';
      const [, payloadB64] = value.split('.');
      if (payloadB64) {
        // base64url decode
        const json = JSON.parse(decodeURIComponent(escape(atob(payloadB64.replace(/-/g, '+').replace(/_/g, '/')))));
        const issuerPoolId = json.iss?.split('/').pop(); // .../userpool/<region>_<poolId>
        if (issuerPoolId && issuerPoolId !== expectedUserPoolId) {
          // issuer doesn't match — remove everything under the expectedPrefix just in case it's corrupt
          names.forEach((name) => {
            if (name.startsWith(expectedPrefix)) deleteCookieEverywhere(name);
          });
        }
      }
    } catch {
      // If decoding fails, do nothing — better to be conservative
    }
  }
}
